module.exports = "- Use the FloatingPeoplePicker to select something other than people\n- Use the FloatingPeoplePicker without sufficient space\n"